// `/relances` layout — Wave 5d Agent 5d.3.
//
// Mounts the runtime relances pages (currently just `pending`) below the
// `_authed` shell. The layout owns route metadata + an `<Outlet>` so child
// routes (today only `pending`, possibly `history` in W6) can stack
// naturally without re-declaring the parent guard.

import { Outlet, createRoute } from '@tanstack/react-router';

import { Route as AuthedLayoutRoute } from '../__layout';

export const Route = createRoute({
  getParentRoute: () => AuthedLayoutRoute,
  path: 'relances',
  component: RelancesLayout,
});

function RelancesLayout() {
  return <Outlet />;
}
